import { render, staticRenderFns } from "./AddAuthorizationLayoutV2.vue?vue&type=template&id=289a3582&scoped=true"
import script from "./AddAuthorizationLayoutV2.vue?vue&type=script&lang=js"
export * from "./AddAuthorizationLayoutV2.vue?vue&type=script&lang=js"
import style0 from "./AddAuthorizationLayoutV2.vue?vue&type=style&index=0&id=289a3582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a3582",
  null
  
)

export default component.exports